import { StatusesAction, SUCCESS_FETCH_STATUSES } from '../actions/statuses'

export type StatusesState = {
  data: {
    id: string
    name: string
    color: string
  }[]
}

const init: StatusesState = {
  data: [],
}

export default function statuses(
  state: StatusesState = init,
  action: StatusesAction
) {
  switch (action.type) {
    case SUCCESS_FETCH_STATUSES:
      return { ...state, data: action.payload.statuses }
  }

  return state
}
